import { func } from '../../main';
import axios from '../../api'
import VueSimpleAlert from "vue3-simple-alert";
const state = {
    ProjectList: [],
    AllProjectList: [],
    ProjectTypeList: [],
    ProjectNoMoreData: false,
};


const getters = {
    GetProjectList(state: any) {
        return state.ProjectList;
    },
    GetAllProjectList(state: any) {
        return state.AllProjectList;
    },
    GetProjectTypeList(state: any) {
        return state.ProjectTypeList;
    },
    GetProjectNoMoreData(state: any) {
        return state.ProjectNoMoreData;
    },
};

const mutations = {
    SetProjectNoMoreData(state: any, val: any) {
        state.ProjectNoMoreData = val;
    },
    SetProjectTypetList(state: any, val: any) {
        state.ProjectTypeList = val;
    },
    SetProjectList(state: any, list: any) {
        state.ProjectList = list;
    },
    SetAllProjectList(state: any, list: any) {
        state.AllProjectList = list;
    }

};

const actions = {
    ProjectAddOrEdit(context: any, item: any) {
        context.commit("SetLoading", true);

        axios.post('Project/ProjectAddOrEdit', item).then((response: any) => {
            context.commit("SetLoading", false);
            if (response.data.isSuccess) {
                func.showSuccessMessage(response.data.message);
                setTimeout(function () { window.location.href = "/ProjectList"; }, 1500);
            } else {
                func.showErrorMessage(response.data.message);
            }

        }, error => {
            func.showErrorMessage("خطا در ارسال اطلاعات");
            context.commit("SetLoading", false);
            console.log(error);
        });
    },
    GetProjectListFromServer(context: any, filter: any) {
        context.commit("SetLoading", true);
        axios.get("Project/GetProjectList", {
            params: {
                text: filter.text,
                personId: filter.personId,
                projectId: filter.projectId,
            }
        })
            .then(data => {
                if (data.data.length < 1) {
                    context.commit("SetWorkTimerNoMoreData", true);
                }
                context.commit("SetProjectList", data.data);
                context.commit("SetLoading", false);
            });
    },
    GetAllProjectListFromServer(context: any, filter: any) {
        context.commit("SetLoading", true);
        axios.get("Project/GetAllProjectList", {
            params: {
                text: filter.text,
            }
        })
            .then(data => {
                if (data.data.length < 1) {
                    context.commit("SetWorkTimerNoMoreData", true);
                }
                context.commit("SetAllProjectList", data.data);
                context.commit("SetLoading", false);
            });
    },
    GetProjectTypeListFromServer(context: any, filter: any) {
        context.commit("SetLoading", true);
        axios.get("Project/GetProjectTypetList", {
            params: {
                isAll: filter.isAll,
                typeId: filter.typeId
            }
        })
            .then(data => {
                context.commit("SetProjectTypetList", data.data);
                context.commit("SetLoading", false);
            });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
